import { saveAs } from "file-saver";

export const downloadFile = async (file) => {
  if (typeof window != "undefined") {
    const downloadResult = await fetch(file.url);
    const blob = await downloadResult.blob();
    saveAs(blob, file.fileName);
  }
};
